import { Injectable } from "@angular/core";
import { Constants } from "../utils/constants";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { UtilsService } from "./utils.service";
import { ApiResponse } from "../classes/api-response";
import { map } from "rxjs/operators";
import { Contract } from "../model/contract";
import { BillingSetup } from "../model/billingSetup";
import { BillingSetupItemArray } from "../model/billingSetupItemArray";
import { BillingItems } from "../model/billingItems";
import * as _ from "lodash";
import { BillingItemsArray } from "../model/billingItemsArray";

@Injectable({
  providedIn: 'root'
})
export class BillingSetupService {

  private readonly roles = Constants.roles;
  private readonly entities = Constants.entities;
  private readonly crtlPathFragment = this.entities.contracts;
  private readonly crtlFullPath = `${environment.apiUrl}/${this.crtlPathFragment}`;
  private readonly ctrlFullPathLS = `${environment.apiUrl}/billing/saveBillingSetup`;
  private readonly ctrlFullPathItems = `${environment.apiUrl}/billing/getBillingItemsBySetupId`;
  private readonly ctrlFullPathItem = `${environment.apiUrl}/billing/getBillingItemById`;
  private readonly ctrlFullPathBoxes = `${environment.apiUrl}/contracts`;

  private readonly crtlPartnerFullPath = `${environment.apiUrl}/${this.crtlPathFragment}-partner`;

  private readonly crtlCustomerFullPath = `${environment.apiUrl}/${this.crtlPathFragment}-customer`;

  constructor(private http: HttpClient) {
  }

  /* public getAllSystemLogs(statuses?: string[]): Observable<SystemLogs[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
.get<ApiResponse>(`${this.crtlFullPath}`, {params})
       .pipe(map(value => value.data as SystemLogs[]));
  } */

  public getAllContracts(statuses?: string[]): Observable<Contract[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}`, { params })
      .pipe(map(value => value.data as Contract[]));
  }

  public getAllPartnerContracts(statuses?: string[]): Observable<Contract[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlPartnerFullPath}`, { params })
      .pipe(map(value => value.data as Contract[]));
  }

  public getAllCustomerContracts(statuses?: string[]): Observable<Contract[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlCustomerFullPath}`, { params })
      .pipe(map(value => value.data as Contract[]));
  }

  public updateBillingSetup(billingSetup: BillingSetupItemArray): Observable<void> {
    return this.http
      .patch<ApiResponse>(`${this.crtlFullPath}/${billingSetup.id}`, billingSetup)
      .pipe(map(() => { }));
  }
  public getContractById(contractId?: number | string, statuses?: string[]): Observable<Contract> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${contractId}`, { params })
      .pipe(map(value => value.data as Contract));
  }
  public getItemsById(billingSetupId?: number | string, statuses?: string[]): Observable<BillingItems[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.ctrlFullPathItems}/${billingSetupId}`, { params })
      .pipe(map(value => value.data as BillingItems[]));
  }
  public getItemById(billingSetupId?: number | string, statuses?: string[]): Observable<BillingItems> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.ctrlFullPathItem}/${billingSetupId}`, { params })
      .pipe(map(value => value.data as BillingItems));
  }
  public getAllResearcherContractById(contractId?: number | string, statuses?: string[]): Observable<BillingItems> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${contractId}`, { params })
      .pipe(map(billingItems => ({ billingItemType: 2, units: _.size(billingItems.data.researchers), unitCost: 0, invoicePeriod: 1 }) as BillingItems));
  }

  public createBillingSetup(billingSetup: BillingSetup, billingItems: Array<BillingItemsArray>, idContract?: number, statuses?: string[]): Observable<BillingSetupItemArray> {
    const headers = { 'Accept-Encoding': 'gzip, deflate, br', 'Connection': 'keep-alive', 'Content-Type': 'application/json' };
    const billingSetupItemsArray = '{ "billingSetup": ' + JSON.stringify(billingSetup) + ', "billingItems": [' + JSON.stringify(billingItems) + ']}';
    console.log(billingSetupItemsArray);
    return this.http
      .post<any>(`${this.ctrlFullPathLS}/${idContract}`, billingSetupItemsArray, { headers })
      .pipe(map(value => value.data as BillingSetupItemArray));
  }
  public createBillingCustomerSetup(billingSetup: BillingSetup, billingItems: Array<BillingItemsArray>, idContract?: number, statuses?: string[]): Observable<BillingSetupItemArray> {
    const headers = { 'Accept-Encoding': 'gzip, deflate, br', 'Connection': 'keep-alive', 'Content-Type': 'application/json' };
    console.log("billingItems service", billingItems);
    const billingSetupItemsArray = '{ "billingSetup": ' + JSON.stringify(billingSetup) + ', "billingItems": ' + JSON.stringify(billingItems) + '}';
    console.log(billingSetupItemsArray);
    return this.http
      .post<any>(`${this.ctrlFullPathLS}/${idContract}`, billingSetupItemsArray, { headers })
      .pipe(map(value => value.data as BillingSetupItemArray));
  }

  public getAllItemsDeliveredByContract(contractId?: number | string, statuses?: string[]): Observable<BillingItems> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.ctrlFullPathBoxes}/${contractId}/boxes`, { params })
      //  .pipe(map(value => _.size(value.data)));
      .pipe(map(billingItems => ({ billingItemType: 1, units: _.size(billingItems.data), unitCost: 0, invoicePeriod: 6 }) as BillingItems));
  }

}

